import Logger from '../logger';

const launchOTPAuth = (args) => {
    Logger.log(`lauchOTPAuth args=${JSON.stringify(args)}`);
    let number = prompt('Podaj numer telefonu');
    Logger.log('OTPAuth, number ->' + number);

    let otp = prompt('Podaj kod jednorazowy');
    Logger.log('client OTP -> ' + otp);

    let otpResult = false;
    if (otp === 1) {
        otpResult = true;
    }

    // window.closer.log({
    //     message: 'identify: otp',
    //     OTPAuth: otpResult,
    //     OTPNumber: number
    // });
    window.closer.identify({
        additionalData: {
            OTPAuth: otpResult,
            OTPNumber: number
        }
    });
};

export { launchOTPAuth };
